var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 39.3168C7 39.3168 4.69104 39.2736 3.57143 37.9803C2.56381 36.8163 2.71429 35.307 2.71429 35.307V8.57415C2.71429 8.57415 2.62815 6.28633 4 5.00991C5.24726 3.84941 7 3.7368 7 3.7368L8.71429 3.76226M7 39.3168L1 46H7L9.57143 42.3546M7 39.3168H11.7143M11.7143 39.3168H24.1429M11.7143 39.3168L9.57143 42.3546M24.1429 39.3168H28.4286M24.1429 39.3168L26.0909 42.3546M28.4286 39.3168C28.4286 39.3168 30.2451 38.7651 31.4286 37.5348C32.612 36.3044 32.7143 34.8615 32.7143 34.8615V9.01982C32.7143 9.01982 32.9073 6.15049 31.4286 5.01028C30.353 4.18097 29.2857 4.06778 29.2857 4.06778L27.5714 4.04232M28.4286 39.3168L34 46H28.4286L26.0909 42.3546M9.57143 42.3546H26.0909M13.8571 33.5247H21.5714M13.8571 30.4059H21.5714M17.7143 10.3563H6.14286V24.6138H17.7143M17.7143 10.3563H29.2857V24.6138H17.7143M17.7143 10.3563V24.6138M8.71429 3.76226V1H11.2857V3.7368M8.71429 3.76226L25 4.00413M27.5714 4.04232V1H25V4.00413M27.5714 4.04232L25 4.00413",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.fabeb9169350cf6b3769b34cf37f3eb2.svg";
export { ForwardRef as ReactComponent };